import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import Services from '../../../service/Services';
import { Dropdown } from 'primereact/dropdown';
import { UseMedia } from "../../Funciones";
import ModalSelectedDates from "./ModalSelectedDates";
import { CambiarFormatoFecha } from "../../Funciones";
/* import Cookies from "universal-cookie"; */
import axios from "axios";

/* const cookies = new Cookies(); */
const TableCopiarActividades = ({ copyDataProp, validateChangeProp, permisoRegistrarProp, dataCopiedRegisterProp, setDataCopiedRegisterProp, uniqueDataProp }) => {


    const inputRef = useRef(null);
    const [dataCopied, setDataCopied] = useState(null)

    const [appService, setAppService] = useState([]);
    const [projectsSession, setProjectsSession] = useState([]);
    const [servicesTypeActivity, setServicesTypeActivity] = useState([]);
    const [serviceBusinessArea, setServiceBusinessArea] = useState([]);
    const [servicesCategory, setServicesCategory] = useState([]);
    const [tipoNovedades, setTipoNovedades] = useState([]);
    const dataPreview = useRef(null)
    const getServices = new Services();

    //Estado que recibe los datos a expandir
    const [expandedRows, setExpandedRows] = useState([]);

    useEffect(() => {
        const source = axios.CancelToken.source(); //Se crea una instancia para luego cancelar las peticiones
        getServices.getCategory().then(data => {
            if (data !== undefined) {
                setServicesCategory(data)
            }
        })

        getServices.getAplicaciones().then(data => {
            if (data !== undefined) {
                setAppService(data)
            }
        })
        getServices.getAsociacionProyectoUsuarioVigente().then(data => {
            if (data !== undefined) {
                setProjectsSession(data)
            }
        })
        getServices.getTipoActividades().then(data => {
            if (data !== undefined) {
                setServicesTypeActivity(data)
            }
        })
        getServices.getAreasNegocio().then(data => {
            if (data !== undefined) {
                setServiceBusinessArea(data)
            }
        })
        getServices.getTipoNovedad().then(data => {
            if (data !== undefined) {
                setTipoNovedades(data)
            }
        });
        /*   cookies.set('dataPreview', copyDataProp) */
        dataPreview.current = copyDataProp
        setDataCopied(copyDataProp.map(item => {
            return {
                actualizadopor: item.actualizadopor,
                aplicacion: item.aplicacion,
                areanegocio: item.areanegocio,
                cliente: item.cliente,
                colaborador: item.colaborador,
                coordinadocon: item.coordinadocon,
                creadopor: item.creadopor,
                descripcionactividad: item.descripcionactividad,
                esadicional: item.esadicional,
                estado: item.estado,
                fecha: item.fecha,
                fechaactualizado: item.fechaactualizado,
                fechacorreoelec: item.fechacorreoelec,
                fechacreacion: item.fechacreacion,
                id: item.id,
                idempresa: item.idempresa,
                notas: item.notas,
                numerohoras: item.numerohoras,
                proyecto: item.proyecto,
                ticket: item.ticket,
                tipoActividad: item.tipoActividad,
                optionSelected: ''
            }
        }))
        return () => {
            if (source) {
                getServices.cancelRequest()
            }
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    //Función que indica cuando sé finaliza la edición y actualiza los datos
    const [selectedDates, setSelectedDates] = useState([]);
    const [optionSelected, setOptionSelected] = useState('');
    const [validateOnRowEditComplete, setValidateOnRowEditComplete] = useState(false)
    const onRowEditComplete = (e) => {
        let _dataCopied = [...dataCopied];
        let { newData, index } = e;
        _dataCopied[index] = {
            ...newData,
            index: index
        };
        setDataCopied(_dataCopied)
        permisoRegistrarProp(true)
        setOcultQuestions(true)
        setDisabledButtonYes(false)
        setDisabledButtonNo(false)
        setValidateOnRowEditComplete(true)
        if (optionSelected === 'No') {
            let arr = []
            _dataCopied.forEach(z => {
                if (z.optionSelected) {
                    if (JSON.parse(z?.optionSelected).selected === 'No') {
                        var newArr = selectedDates?.map(item => {
                            return {
                                ...z,
                                fecha: CambiarFormatoFecha(item),
                                numerohoras: z.numerohoras
                            }
                        })
                        newArr?.forEach(i => {
                            arr.push(i)
                        })
                    }
                    if (arr.length !== 0) {
                        setDataCopiedRegisterProp([...dataCopiedRegisterProp, ...arr])
                    }
                }
            })

        }
    }

    //Estados de validaciones
    const [permissionEdit, setPermissionEdit] = useState(false);

    //Proyecto

    const projectEditorOnChange = (e, options) => {
        options.editorCallback({
            id: e.value.id,
            name: e.value.name
        })
        options.rowData.proyecto.id = e.value.id
        options.rowData.proyecto.nombreproyecto = e.value.name
        /* validateChangeProp(true) */
    }

    const projectEditor = (options) => {
        var proyectoFechaVigente = []
        var d = new Date()
        var dateV = CambiarFormatoFecha(d)

        const result = projectsSession.filter(function (objeto) {
            var idCliente = parseInt(objeto.cliente.id)
            return idCliente === options.rowData.cliente.id
        })

        result.sort(function (a, b) {
            var textA = a.nombre?.toLowerCase();
            var textB = b.nombre?.toLowerCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        const filterDate = result.filter(element => {
            return element.fechafinvigencia >= dateV
        })
        filterDate?.forEach(element => {
            proyectoFechaVigente.push(element)
        })

        const projects = proyectoFechaVigente.map(item => {
            const av = { name: item.nombre, id: parseInt(item.id) }
            return av
        })

        var selectedProjects = {
            id: options.rowData.proyecto.id,
            name: options.rowData.proyecto.nombreproyecto
        }

        return (
            <Dropdown value={selectedProjects} style={{ width: '100%' }} options={projects} optionLabel="name"
                placeholder="Seleccione un proyecto" onChange={(e) => projectEditorOnChange(e, options)} filter emptyMessage="No se encontraron resultados"
                emptyFilterMessage="No se encontraron resultados" resetFilterOnHide
            />
        );
    }
    //Categoria

    const [idCategory, setIdCategory] = useState(null)
    useEffect(() => {
        copyDataProp.forEach(i => {
            setIdCategory(i.tipoActividad.categoria.id)
        })
    }, [copyDataProp]);

    const optionsCategories = servicesCategory.map(item => {
        const av = { name: item.descripcion, id: item.id }
        return av
    })

    const categoryEditorOnChange = (e, options) => {

        options.editorCallback({
            id: e.value.id,
            name: e.value.name
        })
        setPermissionEdit(true)
        options.rowData.tipoActividad.categoria.id = e.value.id
        options.rowData.tipoActividad.categoria.descripcion = e.value.name
        setIdCategory(e.value.id)
        setValueTypeActivity(null)
        /*    validateChangeProp(true) */
    }

    const categoryEditor = (options) => {
        var category = {
            id: options.rowData.tipoActividad.categoria.id,
            name: options.rowData.tipoActividad.categoria.descripcion
        }

        return (
            <>
                <Dropdown value={category} style={{ width: '100%' }} options={optionsCategories} optionLabel="name"
                    onChange={(e) => categoryEditorOnChange(e, options)} id="idCategory" placeholder="Seleccione una categoria" filter emptyMessage="No se encontraron resultados" emptyFilterMessage="No se encontraron resultados" resetFilterOnHide
                />
            </>
        );
    }

    //Tipo de actividad

    const [tipoActividadError, setValidarTipoActividadError] = useState(false)
    const [mensajeTipoActividad, setValidarTipoActividadMensaje] = useState('')
    //Filtrar tipos de actividad por categorias
    const [servicesTypeActivyForCategory, setServicesTypeActivyForCategory] = useState([])
    useEffect(() => {
        //Obtener los tipos de actividad asociado a cada categoria
        if (idCategory !== null) {
            const filter = servicesTypeActivity.filter(obj => {
                return obj.categoria.id === idCategory
            })
            setServicesTypeActivyForCategory(filter)
        }
    }, [idCategory, servicesTypeActivity])// eslint-disable-line react-hooks/exhaustive-deps

    //Pasarle el valor por defecto registrado al tipo de actividad
    const [valueTypeActivity, setValueTypeActivity] = useState(null)
    useEffect(() => {
        copyDataProp.forEach(element => {
            setValueTypeActivity({
                id: element.tipoActividad.id,
                name: element.tipoActividad.nombretipoactividad
            })
        })

    }, [copyDataProp]);

    const typeActivities = servicesTypeActivyForCategory.map(item => {
        const av = { name: item.nombretipoactividad, id: item.id }
        return av
    })

    const typeActivityEditorOnChange = (e, options) => {
        setValueTypeActivity({
            id: e.value.id,
            name: e.value.name
        });
        options.editorCallback({
            id: e.value.id,
            name: e.value.name
        })
        options.rowData.tipoActividad.id = e.value.id
        options.rowData.tipoActividad.nombretipoactividad = e.value.name
        /* validateChangeProp(true) */
        validarTipoActividad(e.value)
        setPermissionEdit(true)
    }


    // Modal para validar si es una actividad o una novedad

    const validarTipoActividad = (nameActivity) => {
        var arrayNews = []
        tipoNovedades.forEach(element => {
            if (nameActivity.name === element.descripcion) {
                arrayNews.push(element)
            }
        })
        if (arrayNews.length !== 0) {
            setValidarTipoActividadError(true)
            setValidarTipoActividadMensaje('Señor usuario la actividad seleccionada pertenece a una novedad, debe dirigirse a la pestaña novedades para registrarla')
            setPermissionEdit(true)
        } else {
            setValidarTipoActividadError(false)
            setValidarTipoActividadMensaje('')
            setPermissionEdit(false)
        }
    }

    const typeActivityEditor = (options) => {
        return (
            <>
                <Dropdown value={valueTypeActivity} style={{ width: '100%' }} options={typeActivities} optionLabel="name"
                    onChange={(e) => typeActivityEditorOnChange(e, options)} placeholder="Seleccione un tipo de actividad" filter emptyMessage="No se encontraron resultados" emptyFilterMessage="No se encontraron resultados" resetFilterOnHide
                    className={tipoActividadError ? "p-invalid" : ""} tooltip={tipoActividadError ? mensajeTipoActividad : ""}
                />
            </>
        );
    }

    //Ticket
    const [ticketError, setTicketError] = useState(false)
    const [messageTicketError, setMessageTicketError] = useState('')

    const reqTicketEditorOnChange = (e, options) => {
        options.editorCallback(e.target.value)
        options.rowData.ticket = e.target.value

        if (e.target.value !== '' && e.target.value.length < 2) {
            setTicketError(true)
            setMessageTicketError('El ticket debe tener más de 2 dígitos')
            setPermissionEdit(true)
        }
        else if (e.target.value.length > 50) {
            setTicketError(true)
            setMessageTicketError('El ticket debe tener menos de 50 dígitos')
            setPermissionEdit(true)
        }
        else {
            setTicketError(false)
            setMessageTicketError('')
            setPermissionEdit(false)
        }
        validateChangeProp(true)
    }


    const reqTicket = (options) => {
        return (
            <div>
                <InputText type="text" value={options.value} className={ticketError ? "p-invalid" : ''} onChange={(e) => reqTicketEditorOnChange(e, options)}
                    placeholder="Registre un ticket" tooltip={ticketError ? messageTicketError : ''}
                />
            </div>
        );
    }

    //Área de negocios
    const businessEditorOnChange = (e, options) => {
        options.editorCallback({
            id: e.value.id,
            name: e.value.name
        });
        options.rowData.areanegocio.id = e.value.id
        options.rowData.areanegocio.nombreareanegocio = e.value.name
        /* validateChangeProp(true); */
    }

    const areas = serviceBusinessArea.map(item => {
        const av = { name: item.nombreareanegocio, id: item.id }
        return av
    })

    const businessArea = (options) => {
        var area = {
            id: options.rowData.areanegocio.id,
            name: options.rowData.areanegocio.nombreareanegocio
        }
        return (
            <Dropdown value={area} style={{ width: '100%' }} options={areas} optionLabel="name" placeholder="Seleccione un área de negocio"
                onChange={(e) => businessEditorOnChange(e, options)} filter emptyMessage="No se encontraron resultados" emptyFilterMessage="No se encontraron resultados"
                resetFilterOnHide
            />
        );
    }

    //Sistema de aplicación


    const appEditorOnChange = (e, options) => {
        options.editorCallback({
            id: e.value.id,
            name: e.value.name
        })
        options.rowData.aplicacion.id = e.value.id
        options.rowData.aplicacion.nombreaplicacion = e.value.name
        validateChangeProp(true)
    }

    const appEditor = (options) => {
        //// llenar aplicaciones asociados sugún el cliente seleccionado 
        const resultAplication = appService.filter(function (object) {
            var idClient = object.idcliente.id.toString()
            return idClient === options.rowData.cliente.id.toString()
        })
        const apps = resultAplication.map(item => {
            const av = { name: item.nombreaplicacion, id: item.id }
            return av
        })
        var app = {
            id: options.rowData.aplicacion.id,
            name: options.rowData.aplicacion.nombreaplicacion
        }

        return (
            <Dropdown value={app} style={{ width: '100%' }} options={apps} optionLabel="name" placeholder="Seleccione una aplicación"
                onChange={(e) => appEditorOnChange(e, options)} filter emptyMessage="No se encontraron resultados" emptyFilterMessage="No se encontraron resultados" resetFilterOnHide
            />
        );
    }

    //Descripción de actividad
    const [activityError, setActivityError] = useState(false)
    const [messageActivityError, setMessageActivityError] = useState('')
    const [newDescriptionActivity, setNewDescriptionActivity] = useState('')
    
    
    const onChangeActivityEditor = (e, options) => {
        options.editorCallback(e.target.value)
        if (e.target.value.length > 0 && e.target.value.length < 10) {
            setActivityError(true)
            setMessageActivityError('La descripción es muy corta')
            setPermissionEdit(true)
        } else if (e.target.value.length > 300) {
            setActivityError(true)
            setMessageActivityError('La descripción es demasiado larga')
            setPermissionEdit(true)
        } else {
            setActivityError(false)
            setMessageActivityError('')
            setPermissionEdit(false)
            setPermissionEdit(false)
        }
    }
    

    function isValidNumber(value) {
            // Verifica si el valor es un número válido
            return /^\d+(\.\d+)?$/.test(value);
    }

    //Función que se ejecuta después de finalizar el input
    const onBlurCapture = (e) => {
        validateChangeProp(true)
        setNewDescriptionActivity(e.target.value)
    }
    const activityEditor = (options) => {
        return (
            <div>
                <InputText type="text" className={activityError ? "p-invalid" : ''} value={options.value} onChange={(e) => onChangeActivityEditor(e, options)}
                    tooltip={activityError ? messageActivityError : ''} onBlurCapture={onBlurCapture}
                />
            </div>
        )
    }

    //Número de horas
    const [hoursError, setHoursError] = useState(false)
    const [messageHoursError, setMessageHoursError] = useState('')
    const [inputHours, setInputHours] = useState('');
    const [errorHours, setErrorHours] = useState(false)
    const [messageHours, setMessageHours] = useState('')
    const [errorEntero, setErrorEntero] = useState(false)
    const [messageEntero, setMessageEntero] = useState('')

    
    //Validar que el  usuario no se exceda del máximo de horas permitidos

    const onChangeHoursEditor = (e, options) => {
        options.editorCallback(e.target.value)
        e.preventDefault();
        
        const validarEntero = isValidNumber(e.target.value)
           
            if (validarEntero === false) {
                setErrorEntero(true)
                setMessageEntero('Debe ingresar números enteros o decimales')
                setPermissionEdit(true)
            }else{
                setErrorEntero(false)
                setPermissionEdit(true)
            }   
        if (e.target.value === '') {
            /* setPermissionEdit(true) */     
                  
            setHoursError(true)
            setMessageHoursError('No puede dejar el campo vacío')
            // permisoRegistrarProp(false)
        }
        else {
            /* setPermissionEdit(false) */
            setHoursError(false)
            setMessageHoursError('')
            setInputHours(e.target.value)
        }
        validateChangeProp(true)
    }
    
    const hoursEditor = (options) => {
        if (inputHours === '') {
            setInputHours(options.rowData.numerohoras)
        }
        return (
            <div>
                <InputText ref={inputRef} type="text" className={hoursError || errorHours || errorEntero ? "p-invalid" : ''} keyfilter="num" value={options.value} onChange={(e) => onChangeHoursEditor(e, options)} tooltip={hoursError ? messageHoursError : '' || errorHours ? messageHours : '' || errorEntero ? messageEntero : ''}/>
            </div>
        )
    }
    const [ocultQuestions, setOcultQuestions] = useState(true)
    const [disabledButtonYes, setDisabledButtonYes] = useState(false)
    const [disabledButtonNo, setDisabledButtonNo] = useState(false)

    const bodyQuestionsEditor = () => {
        return (
            <span></span>
        )
    }

    const [id, setId] = useState(0)
    const questionsEditor = (options) => {
        if (newDescriptionActivity === '') {
            setNewDescriptionActivity(options.rowData.descripcionactividad)
        }
        var option
        if (options.rowData.optionSelected !== undefined && options.rowData.optionSelected !== '') {
            var optionSelected = JSON.parse(options.rowData.optionSelected)
            option = optionSelected.selected
        }
        var objectData = {
            cliente: {
                id: options.rowData.cliente.id
            },
            proyecto: {
                id: options.rowData.proyecto.id
            },
            tipoActividad: {
                id: options.rowData.tipoActividad.id
            },
            areanegocio: {
                id: options.rowData.areanegocio.id
            },
            aplicacion: {
                id: options.rowData.aplicacion.id
            },
            fecha: options.rowData.fecha,
            descripcionactividad: options.rowData.descripcionactividad,
            ticket: options.rowData.ticket
        }
        return (
            <>
                <>
                    <ModalSelectedDates
                        enviarMensajeProp={'selecciono si'}
                        label="Si"
                        dataProp={options.rowData}
                        dataCopiedRegisterProp={dataCopiedRegisterProp}
                        setDataCopiedRegisterProp={setDataCopiedRegisterProp}
                        disabledProp={option === 'No' ? true : disabledButtonYes}
                        setDisabledButtonYesProp={setDisabledButtonYes}
                        setDisabledButtonNoProp={setDisabledButtonNo}
                        copyActivitiesProp={true}
                        validateChangeProp={validateChangeProp}
                        optionSelectedProp={options}
                        idProp={id}
                        setIdProp={setId}
                        uniqueDataProp={uniqueDataProp}
                        objectDataProp={objectData}
                        rowIndexProp={options.rowIndex}
                        newDescriptionActivityProp={newDescriptionActivity}
                        setSelectedDatesProp={setSelectedDates}
                        setOptionSelectedProp={setOptionSelected}
                        setErrorHoursProp={setErrorHours}
                        setMessageHoursProp={setMessageHours}
                        setPermissionEditProp={setPermissionEdit}
                    />
                    <ModalSelectedDates
                        enviarMensajeProp={'selecciono no'}
                        styleProp={{ marginLeft: '3px' }}
                        label="No"
                        dataProp={options.rowData}
                        dataCopiedRegisterProp={dataCopiedRegisterProp}
                        setDataCopiedRegisterProp={setDataCopiedRegisterProp}
                        disabledProp={option === 'Si' ? true : disabledButtonNo}
                        setDisabledButtonYesProp={setDisabledButtonYes}
                        setDisabledButtonNoProp={setDisabledButtonNo}
                        copyActivitiesProp={true}
                        validateChangeProp={validateChangeProp}
                        optionSelectedProp={options}
                        idProp={id}
                        setIdProp={setId}
                        uniqueDataProp={uniqueDataProp}
                        objectDataProp={objectData}
                        rowIndexProp={options.rowIndex}
                        newDescriptionActivityProp={newDescriptionActivity}
                        setSelectedDatesProp={setSelectedDates}
                        setOptionSelectedProp={setOptionSelected}
                        inputHoursProp={inputHours}
                        setErrorHoursProp={setErrorHours}
                        setMessageHoursProp={setMessageHours}
                        setPermissionEditProp={setPermissionEdit}
                    />
                </>
            </>
        )
    }
    useEffect(() => {
        if (validateOnRowEditComplete === true) {
            setDataCopied(dataCopied)
            dataPreview.current = dataCopied
            /* cookies.set('dataPreview', dataCopied) */
        }
    }, [dataCopied]) // eslint-disable-line react-hooks/exhaustive-deps

    const onRowEditCancel = () => {
        setDataCopied(dataPreview.current)
        setOcultQuestions(true)
    }
    let small = UseMedia("(max-width: 760px)");
    //Activar el botón de listo despues de 1 milisegundo despues que se cambie el valor de categoria o tipo de actividad
    useEffect(() => {

        if (hoursError === false && errorHours === false && errorEntero===false) {
            setTimeout(() => {
                setPermissionEdit(false)
            }, 100);
        }

    }, [idCategory, valueTypeActivity, hoursError, errorHours, inputHours])// eslint-disable-line react-hooks/exhaustive-deps

    //Activar el botón de listo despues de 1 milisegundo despues que se cambie el valor de categoria o tipo de actividad
    
    return (
        <div className="card">

            <DataTable value={dataCopied} onRowEditComplete={onRowEditComplete} editMode="row" emptyMessage="No hay datos en el sistema"
                paginator rows={10} /* rowEditValidator={onRowEditValidator} */
                scrollable={small ? false : true} scrollHeight={small ? "" : "50000px"} sortField="cliente.razonsocial" sortOrder={-1}
                expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)} onRowEditCancel={() => onRowEditCancel()}
                onRowEditInit={() => setOcultQuestions(false)}
            >
                <Column style={{ minWidth: '16rem' }} field="tipoActividad.categoria.descripcion" sortable header="Categoria" editor={(options) => categoryEditor(options)} />
                <Column style={{ minWidth: '16rem' }} field="tipoActividad.nombretipoactividad" sortable header="Tipo Actividad" editor={(options) => typeActivityEditor(options)} />
                <Column style={{ minWidth: '16rem' }} field="proyecto.nombreproyecto" sortable header="Proyecto" editor={(options) => projectEditor(options)} />
                <Column style={{ minWidth: '16rem' }} field="ticket" sortable header="Req. Ticket" editor={(options) => reqTicket(options)} />
                <Column style={{ minWidth: '16rem' }} field="areanegocio.nombreareanegocio" sortable header="Área Negocio" editor={(options) => businessArea(options)} />
                <Column style={{ minWidth: '16rem' }} field="aplicacion.nombreaplicacion" sortable header="Sistema Aplicación" editor={(options) => appEditor(options)} />
                <Column style={{ minWidth: '16rem' }} field="descripcionactividad" sortable header="Actividad" editor={(options) => activityEditor(options)} />
                <Column style={{ minWidth: '16rem' }} field="numerohoras" sortable header="Num Horas" editor={(options) => hoursEditor(options)} />
                {ocultQuestions ?
                    <Column />
                    :
                    <Column className="columna" style={{ minWidth: '16rem' }} field="optionSelected" body={bodyQuestionsEditor} header="¿Desea registrar el número de horas por fechas?"
                        editor={(options) => questionsEditor(options)} />
                }
                <Column rowEditor hidden={permissionEdit} />

            </DataTable>
        </div>
    )
}

export default TableCopiarActividades